import es from './es.json';
import en from './us.json';
import pt from './pt.json';

export default {
  es: { products: es },
  en: { products: en },
  pt: { products: pt },
};
